import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import { Article, GetArticlesResponse } from '@/objects/Articles';
import ListaArticulos from '@/components/elements/listas/lista_articulos/ListaArticulos';
import RowNoData from '@/components/elements/RowNoData';
import { numeroCajasPorDefecto } from '@/util/Articulos';

let page = 0;
function LibrosFavoritosScreen() {
    //alert("LibrosFavoritosScreen")

    const { articulosQueries } = useServices();

    const [articulos, setArticulos] = React.useState<Article[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        //alert("useEffect")
        cargarArticulos();
    }, []);

    function cargarArticulos() {
        const datosUsuario = cargarDatosUsuario();
        const limit = numeroCajasPorDefecto();

        articulosQueries?.getLibrosFavoritos(Number(datosUsuario?.id_user), limit, page).then((response: AxiosResponse<Article[]>) => {
            //alert("response" + response.data.articles.length)
            if (response.status == 200) {
                setArticulos(response.data);
            }
        }
        ).catch((error: any) => {
            //alert("error" + error)
        });
    }

    function cargarMas() {
        page++;
        cargarArticulos();
    }

    const styleMargin: React.CSSProperties = {
        margin: "20px"
    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.favoritos.titulo")} />
            <section style={{ ...styleMargin }}>
                {articulos.length > 0 ?
                    <ListaArticulos articles={articulos} onClick={() => { cargarMas() }} t={t} /> :
                    <RowNoData texto={t("common:errores:no_tienes_libros_add_uno")} />
                }
            </section>
        </section>
    );
}

export default LibrosFavoritosScreen;